var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacketSurface(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64161 11.3591H5.66724L5.84673 1L17.6161 1.12821V11.3591H13.4365",
    stroke: "#0073FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6409 3.69165L21.846 3.87114C22.0768 3.87114 22.5999 3.98396 22.846 4.43525C23.0922 4.88653 23.7008 6.28142 23.9743 6.92245V11.1533H22.2819",
    stroke: "#0073FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8206 6.92334H24.0001",
    stroke: "#0073FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.84619H4.51286",
    stroke: "#0073FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25537 5.4104H4.48617",
    stroke: "#0073FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58936 8.02612H4.43553",
    stroke: "#0073FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4107,
    cy: 11.6407,
    r: 1.52566,
    fill: "#0073FF",
    stroke: "#0073FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3089,
    cy: 11.6407,
    r: 1.52566,
    fill: "#0073FF",
    stroke: "#0073FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketSurface);
export default __webpack_public_path__ + "static/media/packetSurface.6aa106e61dfc8ccdb909885ad14dca51.svg";
export { ForwardRef as ReactComponent };